import { render, staticRenderFns } from "./SiderNav.vue?vue&type=template&id=39c1faa7&scoped=true&"
import script from "./SiderNav.vue?vue&type=script&lang=js&"
export * from "./SiderNav.vue?vue&type=script&lang=js&"
import style0 from "./SiderNav.vue?vue&type=style&index=0&id=39c1faa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c1faa7",
  null
  
)

export default component.exports